<template>
  <div class="ccui-home-index">
    <div class="ccui-app-container">
      <!-- 表格及分页 -->
      <div class="ccui-multifunctional-table-wrapper">
        <listBaseTable
          :tableName="tableName"
          :showCheckBox="false"
          :showOp="true"
          :showOpObj="showOpObj"
          :data="tableData"
          :cellStyle="cellStyle"
          :pageNo.sync="pageNo"
          :pageSize.sync="pageSize"
          :pageTotal="totalNum"
          :fixedTableThead="fixedTableThead"
          :unfixedTableThead="unfixedTableThead"
          border
          @handleRowClick="handleRowClick"
          @changeTableTitleWidth="changeTableTitleWidth"
          @handleList="handleList"
        >
          <template slot="schemeCode" slot-scope="{ row }">
            <span>{{ row.schemeCode ? row.schemeCode : "-" }}</span>
          </template>
          <template slot="op" slot-scope="{ row, $index }">
            <!-- 准备中的数据不可进开标详情页面 -->
            <el-button
              size="mini"
              type="text"
              @click="openBid(row, $index)"
              v-if="
                (row.bidStatus == '0' || row.bidStatus == '1') &&
                  row.openStatus != '1'
              "
              >未开启-开标</el-button
            >
            <el-button
              size="mini"
              type="text"
              @click="seeDetail(row, $index)"
              v-if="row.bidStatus == '2' && row.openStatus != '1'"
              >已开启-查看</el-button
            >
          </template>
        </listBaseTable>
      </div>
    </div>
  </div>
</template>

<script>
import { queryApi } from "@/app/bidOpening/api/index.js";
import reqUrl from "@/app/bidOpening/api/taskPreparationUrl.js";
import { ishasAgentId } from "@/basa/utils";
import { schemeColWidth, commonTableWidth } from "@/setting/setting";
export default {
  name: "bidOpening",
  components: {},
  data() {
    return {
      props: {
        label: "name",
        name: "name",
        children: "children",
        isLeaf: "isLeaf"
      },
      // 表格
      tableName: "bidOpeningList", // 默认的tableName 工程中唯一
      showOpObj: {
        showOpSetting: false, // 是否高级设置
        width: 120 // 操作宽度
      },
      unfixedTableTheadAll: Object.freeze([]),
      fixedTableThead: [
        // 锁定表格
        {
          label: "序号",
          prop: "id",
          type: "index",
          width: commonTableWidth.serialNoWidth,
          title: "id"
        },
        {
          label: "方案编号",
          prop: "schemeCode",
          checked: true,
          width: "200",
          slot: "schemeCode"
        }
      ],
      unfixedTableThead: [
        // 非锁定表格
        {
          label: "方案名称",
          prop: "schemeName",
          fixed: false,
          checked: true,
          minWidth: schemeColWidth.schemeName
        },
        {
          label: "采购组织单位",
          prop: "purchaseUnitName",
          minWidth: commonTableWidth.unitName,
          fixed: false,
          checked: true
        },
        {
          label: "标书状态",
          prop: "openStatusStr",
          width: "100",
          fixed: false,
          checked: true
        },
        {
          label: "生效时间",
          prop: "operateTime",
          width: commonTableWidth.dateTimeWidth,
          fixed: false,
          checked: true
        }
      ],
      pageNo: 1,
      pageSize: 10,
      // 表格
      isShowSearch: true,
      isFocus: "1",
      totalNum: 0,
      currentPage: 1,
      pageNoCode: 1,
      tableTopBtn: [{ label: "全部", value: "1" }],
      formData: {
        schemeCode: "", // 方案编号
        schemeName: "" // 方案名称
      },
      list5: [
        { dicKey: "2", dicValue: "开标中" },
        { dicKey: "3", dicValue: "已开标" },
        { dicKey: "4", dicValue: "待唱标" },
        { dicKey: "5", dicValue: "唱标中" }
      ], //开标状态
      formDataSearch: "",
      tableData: [],
      tabMaxHeight: 300,
      tableMaxHeight: 100,
      noRecord: false,
      schemeId: ""
    };
  },
  filters: {
    // 金额过滤
    NumFormat(value, num) {
      if (!value) return "0.00";
      var intPart = parseInt(Number(value.replace(/,/g, "")).toString(), 0); // 获取整数部分
      var intPartFormat = intPart
        .toString()
        .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 将整数部分逢三一断
      var floatPart = "."; // 预定义小数部分
      for (var i = 1; i <= num; i++) {
        floatPart += "0";
      }
      var value2Array = value.split(".");
      // 判断是否为小数
      if (value2Array.length === 2) {
        // 2表示数据有小数位
        floatPart = value2Array[1].toString(); // 拿到小数部分
        if (floatPart.length == num) {
          return intPartFormat + "." + floatPart;
        } else {
          if (floatPart.length > num) {
            if (Number(floatPart.substring(num, floatPart.length)) >= 5) {
              floatPart = (Number(floatPart.substring(0, num)) + 1).toString();
              return intPartFormat + "." + floatPart;
            } else {
              floatPart = floatPart.substring(0, num);
              return intPartFormat + "." + floatPart;
            }
          } else {
            var d = "";
            for (var j = 1; j <= num - floatPart.length; j++) {
              d += "0";
            }
            floatPart = floatPart + d;
            return intPartFormat + "." + floatPart;
          }
        }
      } else {
        // 没有小数位
        return intPartFormat + floatPart;
      }
    }
  },
  created() {},
  activated() {},
  deactivated() {
    if (this.$refs.elSearch) {
      this.$refs.elSearch.isShowBottom = false;
    }
    this.initData();
  },
  watch: {},
  mounted() {
    this.getListData(this.formDataSearch);
    // this.getListData();
  },
  methods: {
    initData() {
      this.formData = {
        schemeCode: "", // 方案编号
        schemeName: "" // 方案名称
      };
      this.schemeId = "";
      this.formDataSearch = "";
      this.pageNo = 1;
      this.pageSize = 10;
      // 表格
      this.isShowSearch = true;
      this.isFocus = "1";
      this.totalNum = 0;
    },
    // 表格
    handleList() {
      // 分页操作列表
      this.getListData(this.formDataSearch);
    },
    changeTableTitleWidth() {
      // 改变头部宽度
    },
    handleRowClick(row, column, event) {
      // 行点击事件
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    // 时间格式化
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },
    // 金额过滤
    NumFormat(value, num) {
      if (!value) return "0.00";
      var intPart = parseInt(Number(value.replace(/,/g, "")).toString(), 0); // 获取整数部分
      var intPartFormat = intPart
        .toString()
        .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 将整数部分逢三一断
      var floatPart = "."; // 预定义小数部分
      for (var i = 1; i <= num; i++) {
        floatPart += "0";
      }
      var value2Array = value.split(".");
      // 判断是否为小数
      if (value2Array.length === 2) {
        // 2表示数据有小数位
        floatPart = value2Array[1].toString(); // 拿到小数部分
        if (floatPart.length == num) {
          return intPartFormat + "." + floatPart;
        } else {
          if (floatPart.length > num) {
            if (Number(floatPart.substring(num, floatPart.length)) >= 5) {
              floatPart = (Number(floatPart.substring(0, num)) + 1).toString();
              return intPartFormat + "." + floatPart;
            } else {
              floatPart = floatPart.substring(0, num);
              return intPartFormat + "." + floatPart;
            }
          } else {
            var d = "";
            for (var j = 1; j <= num - floatPart.length; j++) {
              d += "0";
            }
            floatPart = floatPart + d;
            return intPartFormat + "." + floatPart;
          }
        }
      } else {
        // 没有小数位
        return intPartFormat + floatPart;
      }
    },
    // 页签跳转
    tabChange(data) {},
    // 获取列表数据
    getListData(reqObj) {
      let param = {};
      param = typeof reqObj == "object" ? reqObj : this.formData;
      // let param = this.formData;
      param.pageNo = this.pageNo;
      param.pageSize = this.pageSize;
      param.isShowPageLoading = true;
      param.participantId = JSON.parse(localStorage.getItem("userInfo")).openId;
      if (param.project8 && param.project8.length != 0) {
        param.complierTimeStart = this.dateFormat(
          "YYYY-mm-dd",
          param.project8[0]
        );
        param.complierTimeEnd = this.dateFormat(
          "YYYY-mm-dd",
          param.project8[1]
        );
        param.complierTimeStart += " 00:00:00";
        param.complierTimeEnd += " 23:59:59";
      } else {
        param.complierTimeStart = "";
        param.complierTimeEnd = "";
      }
      queryApi(reqUrl.qryTenderOpenList, param).then(res => {
        if (res) {
          res.data.data.rows.forEach(item => {
            item.isTow = "否";
          });
          this.tableData = res.data.data.rows;
          this.totalNum = res.data.data.recordsTotal;
          this.$emit("setTotalNum", this.totalNum);
        }
      });
    },
    search(searchData) {
      this.pageNo = 1;
      this.formDataSearch = Object.assign({}, this.formData);
      this.getListData(this.formDataSearch);
    },
    // 高级搜索重置
    resetForm() {
      this.formData.schemeCode = "";
      this.formData.schemeName = "";
    },
    openBid(row, index) {
      this.$emit("viewBid", row.schemeParticipantId);
    },
    seeDetail(row, index) {
      let params = {
        schemeId: row.schemeId,
        operateTime: row.operateTime,
        bidStatus: "",
        bidTime: "",
        openPlace: row.openPlace
      };
      this.$emit("viewDetails", params);
    },
    loadNodes(node, resolve) {
      if (node.level === 0) {
        queryApi(reqUrl.qryUnitOrgTree, {
          flag: "0"
        }).then(res => {
          const nodes = res.data.data.map(item => ({
            id: item.orgId,
            data: [],
            name: item.name,
            leaf: item.isOrder != 0,
            partyId: item.partyId
          }));
          resolve(nodes);
        });
      } else {
        queryApi(reqUrl.qryUnitOrgTree, {
          parentId: node.data.partyId,
          flag: 0
        }).then(res => {
          const nodes = res.data.data.map(item => ({
            id: item.orgId,
            name: item.name,
            data: [],
            leaf: item.isOrder != 0,
            partyId: item.partyId
          }));
          resolve(nodes);
        });
      }
    },
    tableTopChange({ value }) {
      this.isFocus = value;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.listenResize);
  },
  beforeRouteLeave(to, from, next) {
    for (var key in this.$vnode.parent.componentInstance.cache) {
      delete this.$vnode.parent.componentInstance.cache[
        ishasAgentId(to.path, key)
      ];
    }
    next();
  }
};
</script>

<style scoped lang="scss">
/deep/ .el-search .el-searchs-box {
  padding-left: 0 !important;
}
/deep/
  .ccui-advanced-search-wrapper
  .el-search
  .el-searchs-bottom
  .el-form-item
  .el-form-item__label {
  min-width: 104px !important;
}
/deep/ .el-table__fixed-right {
  height: 100% !important;
}
</style>
